import React from 'react';
import {
  Grid,
  withStyles,
  Typography,
  AppBar,
  Toolbar,
  Button,
  Drawer,
  Hidden,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { Menu, Close } from '@material-ui/icons';


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  toolbarTitle: {
    flex: 1,
  },
  icon: {
    margin: theme.spacing.unit,
    fontSize: 32,
  },
})

const ListItemLink = (props) => {
  return <ListItem button component="a" divider={true} {...props} />;
}

class Panel extends React.Component {

  state = { sideMenu: false, }

  toggleDrawer = () => {
    this.setState({
      'sideMenu': !this.state.sideMenu,
    })
  }

  render () {
    const { classes, menus } = this.props;
    const header_menus = menus.header_menus

    return (
      <React.Fragment>
        <AppBar position="static" className={classes.appBar} color='default'>
          <Toolbar>
            <Typography variant="h6" color="inherit" noWrap className={classes.toolbarTitle}>
              <Hidden only={['md', 'lg', 'xl']}>
                <Button onClick={this.toggleDrawer}><Menu className={classes.icon} /></Button>
                <Drawer open={this.state.sideMenu} onClose={this.toggleDrawer}>
                  <div tabIndex={0} role="button" onClick={this.toggleDrawer} onKeyDown={this.toggleDrawer} >
                    <Button onClick={this.toggleDrawer}><Close className={classes.icon}/></Button>
                    <List>
                      {header_menus.map(menu => (
                        <ListItemLink key={menu.name} href={menu.url}>
                          <ListItemText primary={menu.name} />
                        </ListItemLink>
                      ))}
                    </List>
                  </div>
                </Drawer>
              </Hidden>
            </Typography>
            <Hidden only={['xs', 'sm']}>
              {header_menus.map(menu => (
                <Button key={menu.name} href={menu.url}>
                  {menu.name}
                </Button>
              ))}
            </Hidden>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    )
  }
}

const Header = withStyles(styles)((props) => <Panel {...props}/>);
export default Header;
